import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardType, CardTypeSlugs, RouteTypes } from '@app/enums/_index';
import { PipesModule } from '@app/pipes/pipes.module';
import { DurationComponent } from '../duration/duration.component';
import { InformationTooltipComponent } from '../information-tooltip/information-tooltip.component';
import { RouteButtonComponent } from '../route-button/route-button.component';

@Component({
  selector: 'app-card',
  imports: [
    CommonModule,
    DurationComponent,
    PipesModule,
    RouterModule,
    InformationTooltipComponent,
    RouteButtonComponent,
  ],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() id: number; // Course or Subscription Id
  @Input() cardType: string; // Ex. Subscription or secondary card heading
  @Input() cardSubType: string; // Ex. Instruction Type or third card subheading withing card body
  @Input() routeType = RouteTypes.INTERNAL; // Default Indicates if the routeType is 'internal' for internal routing, anything else is external including mailTo: emails
  @Input() instructionType: string;
  @Input() title: string; // Primary card title heading
  @Input() icon: string;
  @Input() route: string; // Link route used for card titles and card descriptions
  @Input() buttonRoute: string; // Button Call to action route, but is not necessary the same as the link route
  @Input() mailToDetails: any; // Pass in email mailto (link) information to build email string to be opened by email client
  @Input() secondaryLinkRoute: string; // Secondary link route used to handle a second internal route type (ex. Subscription Required)

  @Input() description: string;
  @Input() sessionDescription: any;
  @Input() showButton = true;
  @Input() showButtonIcon = false;
  @Input() showSubTitle = false;
  @Input() actionLabel: string;
  @Input() secondaryActionLabel: string;
  @Input() showSecondaryButton = false;
  @Input() courseDuration: string;

  @Input() customHeaderPanel: string;
  @Input() customHeaderCss: string;
  @Input() customCardHeightCss: string;
  @Input() customHeadingGroupCss: string;
  @Input() customHeaderTitleCss = 'text-align-left'; // Default text header title left alignment
  @Input() customButtonCss = 'btn-primary'; // Default primary button css
  @Input() queryParams: string;
  @Input() informationTooltip: string;
  @Input() showTooltip: boolean;
  @Input() showErrorMessage: boolean;
  @Input() errorMessage: string;

  /** when `disabled` is true, bind the `disabled` class on the host element */
  @HostBinding('class.disabled')
  get disabledClass(): boolean {
    return this.disabled;
  }

  @Input() disabled = false;
  @Output() sendClick = new EventEmitter<object>();
  @Output() secondarySendClick = new EventEmitter<object>();

  constructor() {}

  /**
   * Default OnInit
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * On click handle from route button component and emit send click output to calling
   * component
   * Emit an event,in this case the button route. This will let the route types of MODAL
   * to check what is clicked.
   * @param linkTypeEvent - this is the event that contains if the click was from a 'link'.
   */
  onClick(linkTypeEvent: any): void {
    const isClicked = true;
    let clickType = linkTypeEvent;
    this.sendClick.emit({ isClicked, clickType });
  }

  /**
   * Secondary On click handle from route button component and emit send click output to calling
   * component to check what is clicked.
   * @param linkTypeEvent - this is the event that contains if the click was from a 'link'.
   */
  secondaryOnClick(linkTypeEvent: any): void {
    const isClicked = true;
    let clickType = linkTypeEvent;
    this.secondarySendClick.emit({ isClicked, clickType });
  }

  /**
   *  cardTypeSlugs enums based on card types
   */
  public get cardTypeSlugs(): typeof CardTypeSlugs {
    return CardTypeSlugs;
  }

  /**
   *  CardType enums based on card types
   */
  public get cardTypeName(): typeof CardType {
    return CardType;
  }
}
